import { Modal } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Button from '~/core/Button'
import Link from '~/core/Link'
import getColor from '~/lib/getColor'

export const PLACEMENT = 'confirmation-modal-odp'
const MODAL_TITLE = 'Please contact your Fictiv representative.'

type ConfirmationModalPropsType = {
    onClose: () => void
    showUploadRevisionModal: boolean
}

export default function ConfirmationModal(props: ConfirmationModalPropsType) {
    const { onClose, showUploadRevisionModal } = props

    return (
        <Modal
            bodyStyle={{ padding: '24px' }}
            centered
            visible={showUploadRevisionModal}
            footer={null}
            closable={false}
            width="550px"
        >
            <Box>
                <InfoCircleOutlined
                    style={{
                        color: getColor('shroudBlue'),
                        fontSize: '21px',
                        marginRight: '18px',
                    }}
                />
                <Box direction="col" flex="1">
                    <Text
                        fontSize="16px"
                        fontWeight={500}
                        color="blackAlpha65"
                        style={{ marginBottom: '12px', width: '90%' }}
                    >
                        {MODAL_TITLE}
                    </Text>
                    <Text
                        color="blackAlpha65"
                        style={{
                            marginBottom: '18px',
                        }}
                    >
                        Uploading revised parts after deposit has been placed is
                        not yet available. If you’re unsure who to contact,
                        please
                        <Link
                            name="chat-with-us"
                            onClick={() => {
                                return //To Do
                            }}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-chat-with-us`}
                        >
                            {' '}
                            chat with us
                        </Link>{' '}
                        and we will get you connected to the right person right
                        away.
                    </Text>
                    <Box justifyContent="end">
                        <Button
                            onClick={onClose}
                            name={`${PLACEMENT}-close`}
                            placement={PLACEMENT}
                            data-test-target={`${PLACEMENT}-close`}
                            style={{ marginLeft: 'auto', marginRight: '0' }}
                            type="primary"
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
